import { Field, Form, Formik } from "formik";
import React from "react";
import validationSchema from "../../../Validation/ValidationSchemas";

const Features = ({
  teams,
  presentations,
  analysis,
  kpi,
  review,
  dataImports,
  capture,
  getAllTagline,
  featurePostUpdateCall,
  onFieldChange,
  disabled,
}) => {
  return (
    <div>
      <Formik
        initialValues={{
          feature1: teams,
          feature2: presentations,
          feature3: analysis,
          feature4: kpi,
          feature5: review,
          feature6: dataImports,
          feature7: capture,
        }}
        validationSchema={validationSchema.featureSchema}
        enableReinitialize
        onSubmit={(values) => featurePostUpdateCall(values)}
      >
        {(formik) => (
          <Form>
            <div className="panel-content conclass-website">
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <label className="email black fs-18 emailtxtweb">
                    FEATURES
                  </label>
                  <p className="black fs-16 regular">Maximum 5 or 6 Words.</p>
                </div>
                <div className="col-lg-8 col-md-12">
                  <Field
                    type="text"
                    name="feature1"
                    className={`form-control w-100 faqtextbox1 ${
                      formik.errors.feature1 && "is-invalid"
                    }`}
                    placeholder="Setup your teams"
                  />
                  <div className="errorMsg fs-14 medium">
                    {formik.touched.feature1 && formik.errors.feature1}
                  </div>
                </div>
                <div className="col-lg-4 col-md-4"></div>
              </div>
              <div className="clear20"></div>

              <div className="row">
                <div className="col-lg-8 col-md-12">
                  <Field
                    type="text"
                    name="feature2"
                    className={`form-control w-100 faqtextbox1 ${
                      formik.errors.feature2 && "is-invalid"
                    }`}
                    placeholder="Streamlined Presentations"
                  />
                  <div className="errorMsg fs-14 medium">
                    {formik.touched.feature2 && formik.errors.feature2}
                  </div>
                </div>
                <div className="col-lg-4 col-md-4"></div>
              </div>
              <div className="clear20"></div>
              <div className="row">
                <div className="col-lg-8 col-md-12">
                  <Field
                    type="text"
                    name="feature3"
                    className={`form-control w-100 faqtextbox1 ${
                      formik.errors.feature3 && "is-invalid"
                    }`}
                    placeholder="In-game Analysis"
                  />
                  <div className="errorMsg fs-14 medium">
                    {formik.touched.feature3 && formik.errors.feature3}
                  </div>
                </div>
                <div className="col-lg-4 col-md-4"></div>
              </div>
              <div className="clear20"></div>
              <div className="row">
                <div className="col-lg-8 col-md-12">
                  <Field
                    type="text"
                    name="feature4"
                    className={`form-control w-100 faqtextbox1 ${
                      formik.errors.feature4 && "is-invalid"
                    }`}
                    placeholder="Customize your KPI's"
                  />
                  <div className="errorMsg fs-14 medium">
                    {formik.touched.feature4 && formik.errors.feature4}
                  </div>
                </div>
                <div className="col-lg-4 col-md-4"></div>
              </div>
              <div className="clear20"></div>
              <div className="row">
                <div className="col-lg-8 col-md-12">
                  <Field
                    type="text"
                    name="feature5"
                    className={`form-control w-100 faqtextbox1 ${
                      formik.errors.feature5 && "is-invalid"
                    }`}
                    placeholder="Share online for players to review"
                  />
                  <div className="errorMsg fs-14 medium">
                    {formik.touched.feature5 && formik.errors.feature5}
                  </div>
                </div>
                <div className="col-lg-4 col-md-4"></div>
              </div>
              <div className="clear20"></div>
              <div className="row">
                <div className="col-lg-8 col-md-12">
                  <Field
                    type="text"
                    name="feature6"
                    className={`form-control w-100 faqtextbox1 ${
                      formik.errors.feature6 && "is-invalid"
                    }`}
                    placeholder="Simplified video & data imports exports"
                  />
                  <div className="errorMsg fs-14 medium">
                    {formik.touched.feature6 && formik.errors.feature6}
                  </div>
                </div>
                <div className="col-lg-4 col-md-4"></div>
              </div>
              <div className="clear20"></div>
              <div className="row">
                <div className="col-lg-8 col-md-12">
                  <Field
                    type="text"
                    name="feature7"
                    className={`form-control w-100 faqtextbox1 ${
                      formik.errors.feature2 && "is-invalid"
                    }`}
                    placeholder="Multi-angle capture"
                  />
                  <div className="errorMsg fs-14 medium">
                    {formik.touched.feature7 && formik.errors.feature7}
                  </div>
                </div>
                <div className="col-lg-4 col-md-4"></div>
              </div>
              <div className="d-flex-align-cent mg-top-20">
                <button
                  type="button"
                  className="cancelbtn mr-2"
                  onClick={() => getAllTagline()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`${
                    formik.isValid ? "saveBtn1" : "saveBtn1 activv"
                  }`}
                  disabled={!formik.isValid}
                >
                  Save
                </button>
              </div>
              <div className="clear20"></div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Features;
